import React from "react";

export const HARVEST_LOSS_ALERT_HELP_TITLE =
  "Alertas de perda de colheita na plataforma";

export function HarvestLossAlertHelpContent({
  toleratedKgHa,
  alertThresholdPercent,
  alertLimitKgHa,
}) {
  const hasLimit =
    alertLimitKgHa != null &&
    Number.isFinite(alertLimitKgHa) &&
    toleratedKgHa != null &&
    Number.isFinite(toleratedKgHa);

  return (
    <>
      <p>
        <strong>Como funciona o alerta</strong>
      </p>
      <p>
        Quando o operador registra uma amostra de perda no app, a plataforma
        compara o resultado (kg/ha) com a <strong>margem tolerada</strong> da
        ordem de serviço somada ao <strong>percentual de alerta</strong> que
        você configurou aqui.
      </p>
      {hasLimit ? (
        <p>
          <strong>Exemplo desta ordem:</strong> margem de{" "}
          {toleratedKgHa.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}{" "}
          kg/ha + {alertThresholdPercent}% = alerta a partir de{" "}
          <strong>
            {alertLimitKgHa.toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}{" "}
            kg/ha
          </strong>
          .
        </p>
      ) : (
        <p>
          <strong>Exemplo:</strong> margem de 50 kg/ha + alerta de 50% → a
          plataforma gera alerta quando a amostra ultrapassar{" "}
          <strong>75 kg/ha</strong>.
        </p>
      )}

      <p>
        <strong>Onde o gestor vê o alerta</strong>
      </p>
      <ul>
        <li>
          Um <strong>número vermelho</strong> aparece na barra lateral, em{" "}
          <strong>Ações pendentes e alertas</strong>.
        </li>
        <li>
          Ao abrir essa seção, cada amostra acima do limite aparece como card
          com operador, máquina, ordem de serviço, kg/ha e local GPS.
        </li>
      </ul>

      <p>
        <strong>Quando o alerta é gerado</strong>
      </p>
      <ul>
        <li>
          Com <strong>internet no app</strong>, a amostra sobe na hora e o
          alerta costuma aparecer na web em poucos segundos.
        </li>
        <li>
          <strong>Sem internet</strong>, o app guarda a amostra localmente. Assim
          que a conexão voltar e os dados sincronizarem, a plataforma recebe a
          amostra e o alerta é criado automaticamente — mesmo que o registro
          tenha sido feito minutos ou horas antes.
        </li>
      </ul>

      <p>
        <strong>Requisito:</strong> informe a <strong>margem tolerada (kg/ha)</strong>{" "}
        e publique a ordem ao operador. Sem margem definida, nenhum alerta é
        gerado.
      </p>
    </>
  );
}
